import { ROUTE_GUARD_ROLES, ROUTE_GUARD_USER_TYPES } from '@/constants/order-approval';

export default function orderApprovalRequestGuard(to, from, next) {
  const { requestId } = to.params;
  const { clinic } = to.query;

  if (!requestId) return false;

  const role = (localStorage.getItem(
    `${process.env.VUE_APP_ACCESS_TOKEN_NAME}Role`
  ) || '').trim();

  const user = JSON.parse(
    localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`) || '{}'
  );

  const roleKey = role.replace(/\s+/g, '-').toLowerCase();

  // Role-based redirect
  if (ROUTE_GUARD_ROLES.includes(role.toUpperCase())) {
    next(`/${roleKey}/checkout/${requestId}?clinic=${clinic}`);
    return true;
  }

  // User type-based redirect
  if (ROUTE_GUARD_USER_TYPES.includes(user.userType.toUpperCase())) {
    next(`/${user.userType.toLowerCase()}/checkout/${requestId}?clinic=${clinic}`);
    return true;
  }

  return false;
}
